import React from 'react';
import { ICurrencyProps } from 'interfaces/currency';
import _ from 'lodash';
import { convertToLocaleString } from 'utils';

const Currency: React.FC<ICurrencyProps> = props => {
  const value = _.isNil(props.amount) ? (props.default || '-') : `$${convertToLocaleString(Number(props.amount).toFixed(2))}`;
  
  return (
    <span>
      <span className="font-weight-bolder">
        {props.negative ? '-' : ''}
        {value}
      </span>
    </span>
  );
};

export default Currency;
